export const GET_CONFIRMED_EMPLOYEES = 'GET_CONFIRMED_EMPLOYEES';
export const GET_EMPLOYEES_BY_DEPARTMENT = 'GET_EMPLOYEES_BY_DEPARTMENT';
